import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { ButtonGeneral } from '@doltech/ui/lib/figma/Button/ButtonGeneral/ButtonGeneral';
import { ModalHeader } from '@doltech/ui/lib/figma/Modal/ModalHeader/ModalHeader';
import { ModalHeaderContentSimpleText } from '@doltech/ui/lib/figma/Modal/ModalHeaderContentSimpleText/ModalHeaderContentSimpleText';
import { ModalFooter } from '@doltech/ui/lib/figma/Modal/ModalFooter/ModalFooter';
import { ModalFooterContentStyles } from '@doltech/ui/lib/figma/Modal/ModalFooterContentStyles/ModalFooterContentStyles';
import { ModalFooterContentButtonGroups } from '@doltech/ui/lib/figma/Modal/ModalFooterContentButtonGroups/ModalFooterContentButtonGroups';

const Body = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  row-gap: 12px;

  padding: 20px 32px;
`;

const Container = styled.div`
  background-color: ${colorsV2.white100};
  border-radius: 12px;
`;

export interface ModalListeningSectionGuideContentProps {
  onStart?: () => void;
}

export const ModalListeningSectionGuideContent = (
  props: ModalListeningSectionGuideContentProps
) => {
  const { onStart } = props;

  return (
    <Container>
      <ModalHeader headerContent={<ModalHeaderContentSimpleText text="Lưu ý" />} divider />
      <Body>
        <ResponsiveTypography.Paragraph variant="regular/16-24" color="black100">
          Audio sẽ play và thời gian sẽ bắt đầu chạy sau khi bạn bấm nút “Start”.
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph variant="regular/16-24" color="black100">
          Bắt đầu ngay khi bạn sẵn sàng nhé !
        </ResponsiveTypography.Paragraph>
      </Body>
      <ModalFooter
        footerContent={
          <ModalFooterContentStyles
            align="right"
            content={
              <ModalFooterContentButtonGroups>
                <ButtonGeneral type="primary" size="large" text="Start" onClick={onStart} />
              </ModalFooterContentButtonGroups>
            }
          />
        }
        divider
      />
    </Container>
  );
};
